/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextDetection = exports.Source = exports.Sorting = exports.SiteMemberStatus = exports.SiteMemberPrivacyStatus = exports.Role = exports.AnimationDetection = void 0;
var AnimationDetection;
(function (AnimationDetection) {
    AnimationDetection["UNKNOWN_ANIMATION_DETECTION"] = "UNKNOWN_ANIMATION_DETECTION";
    AnimationDetection["CONTAINS_ANIMATION"] = "CONTAINS_ANIMATION";
    AnimationDetection["NO_ANIMATION"] = "NO_ANIMATION";
})(AnimationDetection = exports.AnimationDetection || (exports.AnimationDetection = {}));
var Role;
(function (Role) {
    Role["UNDEFINED_ROLE"] = "UNDEFINED_ROLE";
    Role["MEMBER"] = "MEMBER";
    Role["OWNER"] = "OWNER";
    Role["CONTRIBUTOR"] = "CONTRIBUTOR";
})(Role = exports.Role || (exports.Role = {}));
var SiteMemberPrivacyStatus;
(function (SiteMemberPrivacyStatus) {
    SiteMemberPrivacyStatus["UNDEFINED"] = "UNDEFINED";
    SiteMemberPrivacyStatus["PUBLIC"] = "PUBLIC";
    SiteMemberPrivacyStatus["PRIVATE"] = "PRIVATE";
    SiteMemberPrivacyStatus["COMMUNITY"] = "COMMUNITY";
})(SiteMemberPrivacyStatus = exports.SiteMemberPrivacyStatus || (exports.SiteMemberPrivacyStatus = {}));
var SiteMemberStatus;
(function (SiteMemberStatus) {
    SiteMemberStatus["UNDEFINED_STATUS"] = "UNDEFINED_STATUS";
    SiteMemberStatus["APPLICANT"] = "APPLICANT";
    SiteMemberStatus["ACTIVE"] = "ACTIVE";
    SiteMemberStatus["INACTIVE"] = "INACTIVE";
    SiteMemberStatus["BLOCKED"] = "BLOCKED";
    SiteMemberStatus["OFFLINE_ONLY"] = "OFFLINE_ONLY";
})(SiteMemberStatus = exports.SiteMemberStatus || (exports.SiteMemberStatus = {}));
var Sorting;
(function (Sorting) {
    Sorting["DESC"] = "DESC";
    Sorting["ASC"] = "ASC";
})(Sorting = exports.Sorting || (exports.Sorting = {}));
var Source;
(function (Source) {
    Source["UNKNOWN"] = "UNKNOWN";
    Source["HANDLING_SPAM"] = "HANDLING_SPAM";
})(Source = exports.Source || (exports.Source = {}));
var TextDetection;
(function (TextDetection) {
    TextDetection["UNKNOWN_TEXT_DETECTION"] = "UNKNOWN_TEXT_DETECTION";
    TextDetection["CONTAINS_TEXT"] = "CONTAINS_TEXT";
    TextDetection["NO_TEXT"] = "NO_TEXT";
})(TextDetection = exports.TextDetection || (exports.TextDetection = {}));
//# sourceMappingURL=types.js.map